import { useState, useEffect } from 'react';
import './candidateTechProficiency.css';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faMinusCircle, faPen, faPlusCircle, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import TechnicalProficiencyIcon from '../../../../assets/images/Ic_Technical Proficiency.png';
import CandidateTechnicalProficiencyPanel from './candidateTechProficiencyInfoPanel';
import { CandidatePostLoginService } from '../../../../services/candidatePostLoginService';
import { Modal, Form, Button } from 'react-bootstrap';
import CloseIcon from '../../../../assets/images/Ic_close.png';
const CandidateTechnicalProficiencies = ({ techproficiencyDocs = [], candidateId, candidateData, fetchCandidateData }) => {
  const [showAll, setShowAll] = useState(false);
  const [editedTechProficiencies, setEditedTechProficiencies] = useState([]);
  const [editingIndexes, setEditingIndexes] = useState([]);
  const [newTechProficiency, setNewTechProficiency] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [modalTechProficiency, setModalTechProficiency] = useState(null);
  const [modalNewTechProficiency, setModalNewTechProficiency] = useState(null);
  const [savingTechProficiency, setSavingTechProficiency] = useState(false);
  const [modalEditedTechProficiencies, setModalEditedTechProficiencies] = useState([]);
  const [modalNewTechProficiencies, setModalNewTechProficiencies] = useState([]);
  const [modalIndex, setModalIndex] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [removedItems, setRemovedItems] = useState([]);

  useEffect(() => {
    setEditedTechProficiencies(Array.isArray(techproficiencyDocs) ? techproficiencyDocs : []);
  }, [techproficiencyDocs]);

  const handleModalTechProficiencyChange = (index, field, value) => {
    setModalEditedTechProficiencies(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleViewAllClick = () => setShowAll((prev) => !prev);

  // const visibleSkills = showAll ? editedTechProficiencies : editedTechProficiencies?.slice(0, 6);
  const visibleSkills = showAll ? editedTechProficiencies : (editedTechProficiencies || []).slice(0, 6);
  const leftSkills = (visibleSkills || []).filter((_, index) => index % 2 === 0);
  const rightSkills = (visibleSkills || []).filter((_, index) => index % 2 !== 0);
  // const leftSkills = visibleSkills?.filter((_, index) => index % 2 === 0);
  // const rightSkills = visibleSkills?.filter((_, index) => index % 2 !== 0);

  const handleTechProficiencyChange = (index, field, value) => {
    setEditedTechProficiencies(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleModalSave = async () => {
    setSavingTechProficiency(true);
    const errors = [];

    const validatedEdited = modalEditedTechProficiencies.map((tp, index) => {
      const issues = [];
      if (!tp.skill || tp.skill.trim() === '') issues.push(`Skill (row ${index + 1})`);
      if (!tp.rating || tp.rating < 1 || tp.rating > 5) issues.push(`Rating (row ${index + 1})`);

      if (issues.length > 0) errors.push(...issues);
      return {
        skill: tp.skill?.trim() || '',
        rating: tp.rating,
        keyProject: tp.keyProject?.trim() || ''
      };
    });

    const validatedNew = modalNewTechProficiencies.map((tp, i) => {
      const newIssues = [];
      if (!tp.skill || tp.skill.trim() === '') newIssues.push(`Skill (new row ${i + 1})`);
      if (!tp.rating || tp.rating < 1 || tp.rating > 5) newIssues.push(`Rating (new row ${i + 1})`);
      if (newIssues.length > 0) errors.push(...newIssues);

      return {
        skill: tp.skill?.trim() || '',
        rating: tp.rating,
        keyProject: tp.keyProject?.trim() || ''
      };
    });

    if (errors.length > 0) {
      setErrorMessage(`Please fill all the required field(s):\n- ${errors.join('\n- ')}`);
      setSavingTechProficiency(false);
      return;
    }

    // const payload = [...validatedEdited, ...validatedNew];
    const payload = isEditMode
      ? [...validatedEdited, ...validatedNew]
      : [...editedTechProficiencies, ...validatedNew];

    try {
      // await CandidatePostLoginService.submitTechProficiencies(payload);

      await CandidatePostLoginService.submitPanelByType('TECH_PROFICIENCIES', {
        inputName: 'techProficiencies',
        inputList: payload
      });

      await fetchCandidateData();

      setEditedTechProficiencies(payload);
      setModalEditedTechProficiencies([]);
      setModalNewTechProficiencies([]);
      setRemovedItems([]);
      setShowEditModal(false);
      setIsEditMode(false);
    } catch (error) {
      console.error('Failed to save technical proficiency:', error);
      setErrorMessage('Failed to save technical proficiencies. Please try again.');
    } finally {
      setSavingTechProficiency(false);
    }
  };
  return (
    <Container className="profile-technical-proficiency-container">
      {errorMessage && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-box">
            <div className="custom-alert-content">
              <p>{errorMessage}</p>
              <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <Row className="align-items-center mb-3">
        <Col>
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div className="d-flex align-items-center flex-wrap gap-2">
              <h3 className="candidate-heading mb-0 d-flex align-items-center gap-2">
                Technical Proficiency ({editedTechProficiencies?.length ?? 0})
                <img
                  src={TechnicalProficiencyIcon}
                  alt="Technical Proficiency"
                  className=""
                  style={{ maxWidth: '20px', height: 'auto' }}
                />
              </h3>

              <button
                size="sm"
                onClick={() => {
                  setModalEditedTechProficiencies([...editedTechProficiencies]);
                  setModalNewTechProficiencies([]);
                  setIsEditMode(true);
                  setShowEditModal(true);
                }}
                className="candidate-profile-edit-button"
              >
                <FontAwesomeIcon icon={faPen} />
              </button>
            </div>

            <div
              style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500', whiteSpace: 'nowrap' }}
              onClick={() => {
                setModalEditedTechProficiencies([]);
                setModalNewTechProficiencies([{ skill: '', rating: 1 }]);
                setIsEditMode(false);
                setShowEditModal(true);
              }}
              className="candidate-detail-add-head"
            >
              <FontAwesomeIcon icon={faPlusCircle} /> Add Technical Proficiency
            </div>
          </div>
        </Col>
      </Row>


      {newTechProficiency && (
        <Row>
          <Col md={6}>
            <CandidateTechnicalProficiencyPanel
              colorSeed={Math.random()}
              techproficiency={newTechProficiency}
              isEditing={true}
              onFieldChange={(index, field, value) =>
                setNewTechProficiency({ ...newTechProficiency, [field]: value })
              }
            />
          </Col>
        </Row>
      )}

      {/* for larger screens */}
      <Row className="profile-technical-proficiency-content d-none d-md-flex">
        <Col md={6} className="profile-technical-proficiency-left">
          {leftSkills?.map((skill, i) => {
            const index = editedTechProficiencies.findIndex(p => p === skill);
            return (
              <div key={`left-${index}`} style={{ marginBottom: '20px' }}>
                <CandidateTechnicalProficiencyPanel
                  colorSeed={Math.random()}
                  techproficiency={skill}
                  index={index}
                  isEditing={editingIndexes.includes(index)}
                  onFieldChange={handleTechProficiencyChange}
                />
              </div>
            );
          })}
        </Col>
        <div className="profile-technical-vertical-line"></div>

        <Col md={6} className="profile-technical-proficiency-right">
          {rightSkills?.map((skill, i) => {
            const index = editedTechProficiencies.findIndex(p => p === skill);
            return (
              <div key={`right-${index}`} style={{ marginBottom: '20px' }}>
                <CandidateTechnicalProficiencyPanel
                  colorSeed={Math.random()}
                  techproficiency={skill}
                  index={index}
                  isEditing={editingIndexes.includes(index)}
                  onFieldChange={handleTechProficiencyChange}
                />
              </div>
            );
          })}
        </Col>
      </Row>

      {/* for smaller screens */}
      <Row className="d-md-none">
        {visibleSkills?.map((skill, index) => (
          <Col xs={12} key={`small-${index}`} className="profile-technical-proficiency-item-wrapper">
            <div style={{ marginBottom: '20px' }}>
              <CandidateTechnicalProficiencyPanel
                colorSeed={Math.random()}
                techproficiency={skill}
                index={index}
                isEditing={editingIndexes.includes(index)}
                onFieldChange={handleTechProficiencyChange}
              />
            </div>
          </Col>
        ))}
      </Row>

      {editedTechProficiencies?.length > 6 && (
        <Row>
          <Col>
            <a
              className="profile-technical-proficiency-view-all"
              onClick={handleViewAllClick}
            >
              {showAll ? 'View Less' : 'View All'}&nbsp;
              <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown} />
            </a>
          </Col>
        </Row>
      )}

      <Modal show={showEditModal} onHide={() => {
        setShowEditModal(false);
        setIsEditMode(false);
        setRemovedItems([]);
      }} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>{isEditMode ? 'Edit Technical Proficiencies' : 'Add Technical Proficiencies'}</Modal.Title>
          <img
            src={CloseIcon}
            alt="Close"
            onClick={() => {
              setShowEditModal(false);
              setIsEditMode(false);
              setRemovedItems([])
            }} style={{
              cursor: 'pointer',
              width: '24px',
              height: '24px',
            }}
          />
        </Modal.Header>
        <Modal.Body>
          {removedItems.length > 0 && (
            <div className="alert alert-warning mb-3">
              This entry will be removed once you click <strong>Save</strong>.
            </div>
          )}

          {modalEditedTechProficiencies.map((skill, index) => (
            <div key={`modal-edit-${index}`} className="mb-3" style={{ position: 'relative' }}>
              <div style={{ paddingBottom: '2rem' }}>
                <CandidateTechnicalProficiencyPanel
                  colorSeed={Math.random()}
                  techproficiency={skill}
                  index={index}
                  isEditing={true}
                  isInModal={true}
                  onFieldChange={handleModalTechProficiencyChange}
                />
              </div>
              {isEditMode && (

                <div
                  onClick={() => {
                    const removedItem = modalEditedTechProficiencies[index];
                    setRemovedItems(prev => [...prev, removedItem]);

                    const updated = [...modalEditedTechProficiencies];
                    updated.splice(index, 1);
                    setModalEditedTechProficiencies(updated);
                  }}
                  style={{
                    position: 'absolute',
                    bottom: '0.25rem',
                    right: '0.5rem',
                    color: '#F35824',
                    cursor: 'pointer',
                    fontWeight: '500',
                  }}
                >
                  <FontAwesomeIcon icon={faMinusCircle} />
                </div>
              )}
            </div>

          ))}

          {modalNewTechProficiencies.map((tp, index) => (
            <div key={`new-tp-${index}`} className="mb-3" style={{ position: 'relative' }}>
              <div style={{ paddingBottom: '2rem' }}>

                <CandidateTechnicalProficiencyPanel
                  techproficiency={tp}
                  index={index}
                  isEditing={true}
                  isInModal={true}
                  onFieldChange={(i, field, value) => {
                    const updated = [...modalNewTechProficiencies];
                    updated[index] = { ...updated[index], [field]: value };
                    setModalNewTechProficiencies(updated);
                  }}
                  colorSeed={Math.random()}
                />
              </div>
              {isEditMode && (
                <div
                  onClick={() => {
                    const updated = [...modalNewTechProficiencies];
                    updated.splice(index, 1);
                    setModalNewTechProficiencies(updated);
                  }}
                  style={{
                    position: 'absolute',
                    bottom: '0.25rem',
                    right: '0.5rem',
                    color: '#F35824',
                    cursor: 'pointer',
                    fontWeight: '500',
                  }}              >
                  <FontAwesomeIcon icon={faMinusCircle} />
                </div>
              )}
            </div>

          ))}


        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              setShowEditModal(false);
              setModalNewTechProficiency(null);
              setRemovedItems([])
            }}
            className="candidate-profile-edit-cancel"
            disabled={savingTechProficiency}

          >
            Cancel
          </button>
          <button
            onClick={handleModalSave}
            className="candidate-profile-edit-save"
            disabled={savingTechProficiency}
          >
            {savingTechProficiency ? 'Saving...' : 'Save'}
          </button>
        </Modal.Footer>
      </Modal>

    </Container>
  );
};

export default CandidateTechnicalProficiencies;